import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
  ViewRef,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Product, ProductService } from '@spartacus/core';
import { Observable, Subscription } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { CheckoutConstants } from 'src/app/model/checkout.model';
import { CheckoutServiceExtends } from 'src/app/service/checkout/checkout.service';
import { ComponentService } from 'src/app/service/component.service';
import { ShimanoCountryService } from 'src/app/service/country/shimano-country.service';
import { OrderFormDetails } from '../order-form.component';

@Component({
  selector: 'app-order-form-summary',
  templateUrl: './order-form-summary.component.html',
  styleUrls: ['./order-form-summary.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class OrderFormSummaryComponent implements OnInit, AfterContentChecked, OnDestroy {
  product$: Observable<Product>;
  orderFormTotalSelectedSubscription$: Subscription;
  orderFormTotalSelected = 0;
  orderFormTotalPriceSubscription$: Subscription;
  orderFormTotalPrice = 0;
  orderFormDetailsListSubscription$: Subscription;
  orderFormDetailsList: OrderFormDetails[] = [];
  srpSubscription$: Subscription;
  showSrp = false;

  activeCountry$: Observable<string> = this.countryService.getActive();

  showGstExclusive$: Observable<boolean> = this.activeCountry$.pipe(
    take(1),
    switchMap((activeCountry) =>
      this.checkoutServiceExtends.isCheckoutFeatureEnabled$(activeCountry, CheckoutConstants.GST_EXCLUSIVE)
    )
  );
  showGstInclusive$: Observable<boolean> = this.activeCountry$.pipe(
    take(1),
    switchMap((activeCountry) =>
      this.checkoutServiceExtends.isCheckoutFeatureEnabled$(activeCountry, CheckoutConstants.GST_INCLUSIVE)
    )
  );

  constructor(
    private route: ActivatedRoute,
    private productService: ProductService,
    private componentService: ComponentService,
    private cdr: ChangeDetectorRef,
    private countryService: ShimanoCountryService,
    private checkoutServiceExtends: CheckoutServiceExtends
  ) {}

  ngOnInit() {
    this.route.params.pipe(take(1)).subscribe((routeParams) => {
      this.product$ = this.getProductDetails(routeParams.code);
    });

    this.product$.subscribe((product) => {
      if (product && product.baseProduct) {
        this.product$ = this.getProductDetails(product.baseProduct);
      }
    });

    this.orderFormTotalSelectedSubscription$ = this.componentService.orderFormTotalSelected$.subscribe(
      (orderFormTotalSelected) => {
        if (!isNaN(orderFormTotalSelected)) {
          this.orderFormTotalSelected = orderFormTotalSelected;
        }
        this.cdr.detectChanges();
      }
    );

    this.orderFormTotalPriceSubscription$ = this.componentService.orderFormTotalPrice$.subscribe(
      (orderFormTotalPrice) => {
        if (!isNaN(orderFormTotalPrice)) {
          this.orderFormTotalPrice = orderFormTotalPrice;
        }
        this.cdr.detectChanges();
      }
    );

    this.orderFormDetailsListSubscription$ = this.componentService.orderFormDetailsList$.subscribe(
      (orderFormDetailsList) => {
        this.orderFormDetailsList = orderFormDetailsList;
        if (!(this.cdr as ViewRef).destroyed) {
          this.cdr.detectChanges();
        }
      }
    );

    this.srpSubscription$ = this.componentService.srpToggle$.subscribe((checked) => {
      this.showSrp = checked;
      this.cdr.detectChanges();
    });
  }

  getProductDetails(productCode: string): Observable<Product> {
    return this.productService.get(productCode);
  }

  get activeCurrency$(): Observable<string> {
    return this.componentService.activeCurrency$;
  }

  setCustomContext(isCustomTranslationsEnabled: boolean, activeCountry: string, activeLanguage: string) {
    return isCustomTranslationsEnabled ? [activeCountry, activeLanguage].join('-') : null;
  }

  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }

  ngOnDestroy() {
    if (this.orderFormTotalSelectedSubscription$) {
      this.orderFormTotalSelectedSubscription$.unsubscribe();
    }
    if (this.orderFormTotalPriceSubscription$) {
      this.orderFormTotalPriceSubscription$.unsubscribe();
    }
    if (this.orderFormDetailsListSubscription$) {
      this.orderFormTotalPriceSubscription$.unsubscribe();
    }
  }
}
